import React from 'react'
import { MdShare } from "react-icons/md";

function Share({ post }) {
  const generateSlug = (text) =>
    text
      .toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with hyphens
      .replace(/[^\w-]+/g, '')        // Remove punctuation
      .replace(/-+/g, '-')            // Collapse multiple hyphens
      .trim();

  const handleShare = () => {
    if (!post || !post.topic) {
      console.warn("❗ Missing post or topic");
      return;
    }

    const slug = generateSlug(post.topic);
    const postUrl = `${window.location.origin}/${slug}`; // ✅ SEO URL

    if (navigator.share) {
      navigator.share({
        title: post.topic,
        url: postUrl,
      }).catch((err) => console.error("Share failed:", err));
    } else {
      navigator.clipboard.writeText(postUrl).then(() => {
        alert("Link copied!");
      }).catch((err) => console.error("Copy failed:", err));
    }
  };

  return (
    <div className='shareContainer'>
      <button onClick={handleShare} className="share-btn">
        <MdShare className='icon' /> <span>Share</span>
      </button>
    </div>
  );
}


export default Share